import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/qZDbP2YQhG8EcbKYZoFu/locations/dgpqCcuQpF12e7lcCp0k`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="60%"
                  minWidth="250px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/qZDbP2YQhG8EcbKYZoFu/locations/dgpqCcuQpF12e7lcCp0k`}
            >
              <CFView hover>
                <CFImage w="250px" src={orderPickupButton} alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
